import { Link } from 'react-router-dom';

function Logo({ onClick, inverse = false }) {
  return (
    <Link className={`logo ${inverse ? 'logo_inverse' : ''}`} to="/" onClick={onClick} aria-label="Adriatic Masterpiece Residence home">
      <span className="logo__mark">AMR</span>
      <span className="logo__name">Adriatic Masterpiece<br />Residence</span>
    </Link>
  );
}

export default Logo;

